<template>
    <v-container>
        <v-row density="compact">
            <v-col>
                <v-card>
                    <v-card-title>Preferências</v-card-title>
                    <v-card-text>
                        <p class="text-subtitle-1">
                            Alterar tema:
                            <v-btn
                                   :color="$vuetify.theme.current.dark ? 'white' : 'black'"
                                   @click="swapLightDarkTheme()"><v-icon class="mr-2">mdi-theme-light-dark</v-icon>
                                {{ $vuetify.theme.current.dark ? "light" : "dark" }}</v-btn>
                        </p>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row density="compact" v-if="user">
            <v-col>
                <v-card>
                    <v-card-title>Privacidade e comunicação</v-card-title>
                    <v-card-text>
                        <v-switch
                                  v-model="lgpdChannels.email"
                                  label="E-mail"
                                  color="primary"
                                  density="compact"
                                  hide-details
                                  :disabled="savingLgpd"></v-switch>
                        <v-switch
                                  v-model="lgpdChannels.whatsapp"
                                  label="WhatsApp"
                                  color="primary"
                                  density="compact"
                                  hide-details
                                  :disabled="savingLgpd"></v-switch>
                        <v-switch
                                  v-model="lgpdChannels.push"
                                  label="Push"
                                  color="primary"
                                  density="compact"
                                  hide-details
                                  :disabled="savingLgpd"></v-switch>
                        <p class="text-caption mt-2">
                            Comunicações essenciais ao serviço, como recuperação de senha, podem continuar por e-mail mesmo se você desligar o canal de avisos.
                        </p>
                        <p class="mt-2">
                            <span class="fakeLink" @click="toggleLgpdPolicy">Política de privacidade</span>
                        </p>
                        <pre
                             v-if="showLgpdPolicy"
                             class="text-body-2"
                             style="white-space:pre-wrap">{{ lgpdPolicy }}</pre>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn :disabled="savingLgpd" @click.stop="saveLgpdPreferences">
                            <v-icon>mdi-content-save</v-icon>
                            Salvar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <v-row density="compact" v-if="isGroupAdmin">
            <v-col cols="12">
                <v-card v-if="api.storage.isGroupSelected()">
                    <v-card-title>Configurações de Grupo: {{ api.storage.selectedGroup().name }}</v-card-title>
                    <v-card-text>
                        <AutocompleteSelectCashflowCategory label="Rubrica de Tarifas"
                                                            :user="user"
                                                            :modelValue="defaultTaxCategory"
                                                            @update:modelValue="defaultTaxCategoryUpdated"
                                                            return-object
                                                            :disabled="!isAdmin"
                                                            :clearable="false"
                                                            :rules="rules.required"
                                                            :rquired="true"
                                                            :groupId="api.storage.selectedGroup()?.id" />
                        <AutocompleteSelectCashflowCategory label="Rubrica de Mensalidade"
                                                            :user="user"
                                                            :modelValue="defaultSubscriptionCategory"
                                                            @update:modelValue="defaultSubscriptionCategoryUpdated"
                                                            return-object
                                                            :disabled="!isAdmin"
                                                            :clearable="false"
                                                            :rules="rules.required"
                                                            :rquired="true"
                                                            :groupId="api.storage.selectedGroup()?.id" />
                        <AutocompleteSelectCashflowCategory label="Rubrica de Vendas Loja / PDV"
                                                            :user="user"
                                                            :modelValue="defaultPosCategory"
                                                            @update:modelValue="defaultPosCategoryUpdated"
                                                            return-object
                                                            :disabled="!isAdmin"
                                                            :clearable="!configuration?.default_pos_category"
                                                            :rules="configuration?.default_pos_category ? rules.required : []"
                                                            :rquired="!!configuration?.default_pos_category"
                                                            :groupId="api.storage.selectedGroup()?.id" />
                        <v-alert
                                 v-if="isGroupAdmin && api.storage.isGroupSelected() && !configuration?.default_pos_category"
                                 type="warning"
                                 variant="tonal"
                                 density="compact"
                                 class="mt-2">
                          Rubrica de vendas PDV não configurada — vendas funcionam, mas sem classificação contábil.
                        </v-alert>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn v-if="isAdmin"
                               :disabled="requestingAPI"
                               @click.stop="saveGroupConfiguration">
                            <v-icon>mdi-content-save</v-icon>
                            Salvar
                        </v-btn>
                    </v-card-actions>
                </v-card>
                <span v-else>Selectione um Grupo</span>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>

import AutocompleteSelectCashflowCategory from '@/components/AutocompleteSelectCashflowCategory.vue';
import api from '@/services'

export default {
  setup() {
    return { api }
  },
    components: {
        AutocompleteSelectCashflowCategory
    },
    computed: {
        isAdmin() {
            return this.user?.access_level >= this.$USER_ACCESS_LEVELS_DIC.ADMIN.value;
        },
        isGroupAdmin() {
            return this.isAdmin || this.user?.access_level === this.$USER_ACCESS_LEVELS_DIC.GROUP_ADMIN.value;
        },
    },
    beforeMount() {
        const vm = this;

        vm.selectedGroup();
        vm.loadLgpdStatus();
    },
    mounted() {
        this.loadLgpdStatus();
    },
    data() {
        return {
            requestingAPI: false,
            configuration: null,
            defaultTaxCategory: null,
            defaultSubscriptionCategory: null,
            defaultPosCategory: null,
            lgpdChannels: { email: true, whatsapp: true, push: true },
            lgpdPolicy: '',
            showLgpdPolicy: false,
            savingLgpd: false,
            rules: {
                required: [(v) => !!v || "Campo obrigatório"],
            },
        }
    },
    methods: {
        swapLightDarkTheme() {
            var vm = this;
            let _dark = vm.$vuetify.theme.current.dark;

            if (_dark) {
                vm.$vuetify.theme.change("light");
                localStorage._dark = 0;
            } else {
                vm.$vuetify.theme.change("dark");
                localStorage._dark = 1;
            }
        },
        saveGroupConfiguration() {
            const vm = this;

            if (!vm.requestingAPI) {
                const data = {
                    ...api.storage.selectedGroup(),
                    configuration: {
                        ...vm.configuration,
                        default_tax_category: vm.defaultTaxCategory.id,
                        default_subscription_category: vm.defaultSubscriptionCategory.id,
                        default_pos_category: vm.defaultPosCategory?.id
                          ?? vm.configuration?.default_pos_category
                          ?? null,
                    }
                };

                // console.log(data);
                vm.requestingAPI = true;
                return new Promise((resolve, reject) => {
                    api.group.update(data).then(result => {
                        api.storage.selectGroup(result);
                        vm.$notify({
                            type: 'success',
                            text: 'Configuração Salva!'
                        });
                        resolve(result);
                    }).catch(error => {
                        vm.$notify({
                            type: 'error',
                            text: error.message
                        });
                        reject(error);
                    }).finally(() => {
                        vm.requestingAPI = false;
                    });
                });
            } else {
                console.log('Busy');
            }
        },
        loadTaxCategory() {
            const vm = this;

            // if (!vm.requestingAPI) {
                vm.requestingAPI = true;
                return new Promise((resolve, reject) => {
                    api.cashFlowCategory.get({ id: vm.configuration.default_tax_category })
                        .then(result => {
                            vm.defaultTaxCategoryUpdated(result);
                        })
                        .catch(err => {
                            if (err.message) {
                                vm.$notify({
                                    type: 'error',
                                    text: err.message
                                })
                            }
                            reject(err);
                        })
                        .finally(() => {
                            vm.requestingAPI = false
                        });
                });
            // } else {
            //     console.log('Busy');
            // }
        },
        loadSubscriptionCategory() {
            const vm = this;

            // if (!vm.requestingAPI) {
                vm.requestingAPI = true;
                return new Promise((resolve, reject) => {
                    api.cashFlowCategory.get({ id: vm.configuration.default_subscription_category })
                        .then(result => {
                            vm.defaultSubscriptionCategoryUpdated(result);
                        })
                        .catch(err => {
                            if (err.message) {
                                vm.$notify({
                                    type: 'error',
                                    text: err.message
                                })
                            }
                            reject(err);
                        })
                        .finally(() => {
                            vm.requestingAPI = false
                        });
                });
            // } else {
            //     console.log('Busy');
            // }
        },
        defaultTaxCategoryUpdated(newValue) {
            const vm = this;

            if (!vm.configuration) {
                vm.configuration = {
                    default_tax_cateogry: newValue?.id
                };
            } else {
                vm.configuration['default_tax_category'] = newValue?.id;
            }
            vm.defaultTaxCategory = newValue;
        },
        defaultSubscriptionCategoryUpdated(newValue) {
            const vm = this;

            if (!vm.configuration) {
                vm.configuration = {
                    default_subscription_cateogry: newValue?.id
                };
            } else {
                vm.configuration['default_subscription_category'] = newValue?.id;
            }
            vm.defaultSubscriptionCategory = newValue;
        },
        loadPosCategory() {
            const vm = this;
            if (!vm.configuration?.default_pos_category) return Promise.resolve(null);
            vm.requestingAPI = true;
            return api.cashFlowCategory.get({ id: vm.configuration.default_pos_category })
                .then(result => {
                    vm.defaultPosCategoryUpdated(result);
                })
                .catch(err => {
                    if (err?.message) {
                        vm.$notify({ type: 'error', text: err.message });
                    }
                })
                .finally(() => {
                    vm.requestingAPI = false;
                });
        },
        defaultPosCategoryUpdated(newValue) {
            const vm = this;
            if (!vm.configuration) {
                vm.configuration = {};
            }
            // Once set on server, never write null from clear
            if (vm.configuration.default_pos_category && !newValue) {
                return;
            }
            vm.configuration.default_pos_category = newValue?.id ?? null;
            vm.defaultPosCategory = newValue;
        },
        loadLgpdStatus() {
            const vm = this;

            return api.lgpd.status()
                .then(status => {
                    if (status?.channels) {
                        vm.lgpdChannels = {
                            email: !!status.channels.email,
                            whatsapp: !!status.channels.whatsapp,
                            push: !!status.channels.push,
                        };
                    }
                    if (status?.policy) {
                        vm.lgpdPolicy = status.policy;
                    }
                })
                .catch(err => {
                    if (err?.response?.status === 401) return;
                    console.warn(err);
                });
        },
        toggleLgpdPolicy() {
            const vm = this;

            vm.showLgpdPolicy = !vm.showLgpdPolicy;
            if (vm.showLgpdPolicy && !vm.lgpdPolicy) {
                api.lgpd.policy()
                    .then(payload => {
                        if (payload?.policy) vm.lgpdPolicy = payload.policy;
                    })
                    .catch(err => {
                        console.warn(err);
                    });
            }
        },
        saveLgpdPreferences() {
            const vm = this;

            if (vm.savingLgpd) {
                return;
            }
            vm.savingLgpd = true;
            return api.lgpd.preferences({ channels: vm.lgpdChannels })
                .then(() => {
                    vm.$notify({
                        type: 'success',
                        text: 'Preferências de comunicação salvas!',
                    });
                })
                .catch(error => {
                    if (error?.response?.status === 401) return;
                    if (error?.message) {
                        vm.$notify({
                            type: 'error',
                            text: error.message,
                        });
                    }
                })
                .finally(() => {
                    vm.savingLgpd = false;
                });
        },
        selectedGroup(group) {
            const vm = this;

            if (api.storage.isGroupSelected()) {
                vm.configuration = api.storage.selectedGroup().configuration || {};
                if (vm.configuration?.default_tax_category) {
                    vm.loadTaxCategory();
                }
                if (vm.configuration?.default_subscription_category) {
                    vm.loadSubscriptionCategory();
                }
                if (vm.configuration?.default_pos_category) {
                    vm.loadPosCategory();
                } else {
                    vm.defaultPosCategory = null;
                }
            }
        },
    },
    props: {
        user: Object,
    },
    watch: {}
};
</script>